/**
 * Transaction filtering utilities — single source of truth.
 *
 * The backend stores recurring transactions as TWO docs:
 *   1. a TEMPLATE  (`recurring: true && !isRecurringInstance`) — the blueprint
 *   2. INSTANCES  (`isRecurringInstance: true`)                — one per occurrence
 *
 * Templates must NEVER be included in financial sums (income, expenses,
 * balance, burn rate, etc.) — they would double-count every recurring
 * stream. Always pass transactions through `realTransactions()` (or use
 * `isRealTransaction`) before computing totals.
 */

export function isRecurringTemplate(t) {
  return Boolean(t && t.recurring === true && t.isRecurringInstance !== true);
}

/** A "real" transaction is anything that actually moved money (not a template). */
export function isRealTransaction(t) {
  return !isRecurringTemplate(t);
}

export function realTransactions(transactions) {
  if (!Array.isArray(transactions)) return [];
  return transactions.filter(isRealTransaction);
}
